module.exports = __webpack_public_path__ + "static/media/rt-bus-route-2.025732f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/markers/rt-bus-route-2.svg
// module id = 293
// module chunks = 0